import type { RoomPlayerSummary } from '@completto/shared';
import { html, View } from 'rune-ts';

export type PlayerListData = {
  players: readonly RoomPlayerSummary[];
  myPlayerId: string;
  amHost: boolean;
  onKick: (playerId: string) => void;
};

export class PlayerListView extends View<PlayerListData> {
  override template() {
    const { players, myPlayerId, amHost } = this.data;
    const items = players.map((p) => {
      const dot = p.connected ? '🟢' : '🟡';
      const hostLabel = p.isHost
        ? html`<span class="text-xs text-card-brass ml-1">[호스트]</span>`
        : html``;
      const meLabel =
        p.id === myPlayerId
          ? html`<span class="text-xs text-emerald-600 ml-1">[나]</span>`
          : html``;
      const kickBtn =
        amHost && p.id !== myPlayerId
          ? html`<button
              type="button"
              data-kick-id="${p.id}"
              class="rounded bg-rose-600 hover:bg-rose-500 px-2 py-1 text-xs"
            >킥</button>`
          : html``;
      return html`
        <li class="flex items-center justify-between rounded-lg bg-wood-paper ring-1 ring-wood-sand px-3 py-2">
          <span class="text-sm truncate text-wood-ink">
            ${dot} ${p.nickname}${hostLabel}${meLabel}
          </span>
          ${kickBtn}
        </li>
      `;
    });

    return html`
      <ul class="player-list flex flex-col gap-1.5">
        ${items}
      </ul>
    `;
  }

  protected override onMount(): void {
    this.element().addEventListener('click', (e) => {
      const target = e.target;
      if (!(target instanceof HTMLElement)) return;
      const btn = target.closest<HTMLButtonElement>('[data-kick-id]');
      if (!btn) return;
      const id = btn.dataset.kickId;
      if (id) this.data.onKick(id);
    });
  }
}
